import { InfoReturnOptions, InfoSupplier } from '../../ReceivementTypes'
import { getReceivementAgreementInfo } from 'src/utils/getReceivementAgreementInfo'
import * as S from './SupplierInfo.style'

interface PropsInfoSupplier {
  info: InfoReturnOptions,
  withActions?: boolean
  withSwapInfo?: boolean
}

const SupplierInfo = ({ info, withActions = true, withSwapInfo = false }: PropsInfoSupplier) => {
  const { infoSupplier, possibleActions } = getReceivementAgreementInfo(info)

  return (
    <S.Container>
      <S.SupplierInfo>Fornecedor {infoSupplier === InfoSupplier.ACCEPT_NFD ? InfoSupplier.NOT_ACCEPT_NFD : infoSupplier} {withSwapInfo && `e ${info.allowProductExchange ? 'ACEITA TROCA' : 'NÃO ACEITA TROCA'} `}</S.SupplierInfo>
      {
        withActions && (
          <>
            <S.Action>Ações disponíveis:</S.Action>
            <ul>
              {possibleActions.map((a, i) => (
                <S.PossibleActionName key={i}>
                  {a.name}{a.description && <S.PossibleActionDescription> {a.description}</S.PossibleActionDescription>}
                </S.PossibleActionName>
              ))}
            </ul>
          </>
        )
      }
    </S.Container>
  )
}

export { SupplierInfo }
